// extracted by mini-css-extract-plugin
export default {"imageContainer":"Product_imageContainer__HZ8u6","image":"Product_image__JjWQ3","footer":"Product_footer__w10y4","button":"Product_button__M9kP6"};